/**
 * Ad platforms are supposed to replace these before the click.
 * `{campaignid}`, `{campaignname}`, and `{{campaign.name}}` arrive only when
 * that replacement never happened. They are not campaign names.
 */
const UNRESOLVED_UTM_MACRO = /\{\{?[^{}]+\}+\}?/;

function containsUnresolvedMacro(value: string): boolean {
  if (UNRESOLVED_UTM_MACRO.test(value)) return true;
  try {
    const decoded = decodeURIComponent(value);
    return decoded !== value && UNRESOLVED_UTM_MACRO.test(decoded);
  } catch {
    return false;
  }
}

/** True when the value still contains an unexpanded `{...}` or `{{...}}` macro. */
export function isUnresolvedUtmValue(value: string | null | undefined): boolean {
  if (!value) return false;
  return containsUnresolvedMacro(value);
}

/**
 * Keeps a real UTM value. An unresolved macro becomes null. Missing values
 * stay missing so a partial attribution object is not filled in.
 */
export function cleanUtmField(
  value: string | null | undefined,
): string | null | undefined {
  if (typeof value !== "string") return value;
  if (containsUnresolvedMacro(value)) return null;
  return value;
}
